<div class="google-maps-container" fxLayout="column" fxLayoutGap="0.5rem">
    <form *ngIf="chooseAddress" class="address-form">
        <mat-form-field class="address-field">
            <input #search matInput autocapitalize="off" spellcheck="false"
                   (keydown.enter)="$event.preventDefault()"
                   [placeholder]="'Enter address'|i18n">
        </mat-form-field>
    </form>
    <agm-map *ngIf="coordinates" [latitude]="coordinates.latitude" [longitude]="coordinates.longitude"
             mapTypeId="hybrid" [zoom]="INITIAL_ZOOM" (mapReady)="onMapReady($event)">
        <agm-marker *ngIf="showMarker"
                    [latitude]="coordinates.latitude" [longitude]="coordinates.longitude"
                    [markerDraggable]="chooseAddress"
                    [iconUrl]="'assets/main-marker.svg'"
                    [title]="'Community Headquarters'|i18n"
                    (dragEnd)="onMarkerDragEnd($event)">
        </agm-marker>
        <agm-map-type-control>
            <button mat-flat-button>{{'Satellite'|i18n}}</button>
            <button mat-flat-button>{{'RoadMap'|i18n}}</button>
        </agm-map-type-control>
    </agm-map>
    <agm-map *ngIf="locations" mapTypeId="hybrid" (mapReady)="onMapReady($event)">
        <agm-map-type-control>
            <button mat-flat-button>{{'Satellite'|i18n}}</button>
            <button mat-flat-button>{{'RoadMap'|i18n}}</button>
        </agm-map-type-control>
    </agm-map>
</div>
